const initialState = {
  enabled: false, redirect: null,
};

export default function navigableReducer(state = initialState, { type, payload }) {
  switch (type) {
    case 'NAVIGATION_DISABLE': {
      const { redirect } = payload;
      return { enabled: false, redirect };
    }
    case 'NAVIGATION_ENABLE': {
      return initialState;
    }
    default:
      return state;
  }
}
